import { Suspense, useEffect, useState } from "react";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import FullScreenSpinner from "../components/FullScreenSpinner";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  BACKEND_URL,
  BoTokenAtom,
  BoUserIdAtom,
  BoUserTypeAtom,
  UserObjectIdAtom,
} from "../Atoms";
import { OrangeButton } from "../common/Common";
import { BoNetUtil, getReturnUrl, useEffectOnce } from "../common/Util";

export function CallbackLayout(props) {
  useEffect(() => {
    console.log(`window.history.state = ${window.history.state.idx}`);
  }, []);
  return (
    <div className="app">
      <Suspense fallback={<FullScreenSpinner />}>
        <Outlet />
      </Suspense>
    </div>
  );
}

export function KakaoCallback(props) {
  return <SocialCallback portal="kakao" />;
}

export function NaverCallback(props) {
  return <SocialCallback portal="naver" />;
}

export function GoogleCallback(props) {
  return <SocialCallback portal="google" />;
}

export function AppleCallback(props) {
  return <SocialCallback portal="apple" />;
}

function SocialCallback(props) {
  // props.portal: kakao, naver, google, apple ...
  const [searchParams, setSearchParams] = useSearchParams();

  const [boToken, setBoToken] = useRecoilState(BoTokenAtom);
  const [boUserType, setBoUserType] = useRecoilState(BoUserTypeAtom);
  const [userObjectId, setUserObjectId] = useRecoilState(UserObjectIdAtom);
  const boUserId = useRecoilValue(BoUserIdAtom); // 쓰지는 않아도, 불러줘야 recoil selector에 의해 자동으로 local storage에 기록됨
  const [code, setCode] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [goTerms, setGoTerms] = useState(false); // 약관동의로 갈 건가?
  const navigate = useNavigate();

  //2502 추가: 이화면에서 멈춤 현상이 한번 재현되서 추가함.
  const [key, setKey] = useState(0);
  const handleRefresh = () => {
    setKey((prevKey) => prevKey + 1);
  };

  useEffectOnce(() => {
    const _code = searchParams.get("code");
    //const _state = searchParams.get('state');
    const _state = boUserId; // anonymous id와 social account를 연결하기 위해, BO로 보냄
    if (code === _code) return; // 두번 호출되어서 KOE320 에러나는 것 막아야 함
    setCode(_code);

    const redirectUrl = `${window.location.protocol}//${window.location.host}/callback_${props.portal}`;
    BoNetUtil.get_plain(
      `${BACKEND_URL}/vws/bo/auth/oauth2/${props.portal}/info`,
      { code: _code, state: _state, redirect_uri: redirectUrl },
      (resp) => {
        const userInfo = resp.data;
        console.log("userInfo = %o", userInfo);

        // 이미 가입한 회원이면
        console.log("========== 2단계 signin API 호출 ==========");
        console.log("URL:", `${BACKEND_URL}/vws/bo/auth/oauth2/${props.portal}/signin`);
        console.log("Body (userInfo):", userInfo);
        console.log("Body (JSON):", JSON.stringify(userInfo, null, 2));
        console.log("==========================================");
        
        BoNetUtil.post_plain(
          `${BACKEND_URL}/vws/bo/auth/oauth2/${props.portal}/signin`,
          userInfo,
          (resp) => {
            console.dir(resp.data);
            const tpair = {
              accessToken: resp.data.accessToken,
              refreshToken: resp.data.refreshToken,
            };
            setBoToken(tpair);
            setBoUserType(props.portal);
            localStorage.setItem('last-login-provider', props.portal);
            const url = getReturnUrl();

            BoNetUtil.dcolSignInUp(
              //
              (resp) => {
                // 여기서 userobjectid 를 set 함
              },
              (err) => {
                console.error(err);
                console.log(
                  `signupMerge signUp=${resp.data.signUp}, old=${resp.data.prvUserObjectId} -> new=${resp.data.userObjectId}`
                );
                // BoNetUtil.post(
                //   `${BACKEND_URL}/api/v1/oauth/bo/signup/merge`,
                //   {
                //     userObjectId: resp.data.userObjectId,
                //     prvUserObjectId: resp.data.prvUserObjectId,
                //   },
                //   (resp) => {
                //     console.log("social userid merged=>");
                //     console.dir(resp.data);
                //     const url = getReturnUrl();
                //     console.log(`return url = ${url}`);
                //     //navigate(url || "/", {replace: true});
                //     window.location.href = url || "/";
                //   },
                //   (err) => {
                //     console.error(err);
                //   }
                // );
              }
            );

            window.location.href = url || "/";
          },
          (err) => {
            console.error(err);
            console.dir(err);
            
            // 신규 회원가입인 경우 (404 또는 특정 에러 코드)
            // 카카오 회원가입 시 개인정보 동의 페이지로 리다이렉트
            const errorCode = err.response?.data?.code;
            const errorStatus = err.response?.status;
            
            // 404 또는 신규 회원 관련 에러 코드인 경우 동의 페이지로 이동
            if (errorStatus === 404 || errorCode === "USER_NOT_FOUND" || errorCode === "NEW_USER") {
              console.log("신규 회원가입 감지 - 개인정보 동의 페이지로 이동");
              navigate("/social-agree", {
                state: {
                  portal: props.portal,
                  userInfo: userInfo,
                  code: _code,
                  state: _state,
                },
                replace: true,
              });
              return;
            }
            
            // 기타 에러는 에러 메시지 표시
            if (err.response?.data) {
              setErrorMsg(
                `${err.response.data.code}: ${err.response.data.message}`
              );
            } else {
              setErrorMsg(`${err}`);
            }
          }
        );
      },
      (err) => {
        console.error(err);
        if (err.response?.data) {
          setErrorMsg(
            `${err.response.data.code}: ${err.response.data.message}`
          );
        } else {
          setErrorMsg(`${err}`);
        }
      }
    );
  }, [key]);

  return (
    <>
      <div>
        {errorMsg ? <ShowErrorMsg message={errorMsg} /> : <ShowOkMsg />}
      </div>

      {/*//2502 추가: 이화면에서 멈춤 현상이 한번 재현되서 추가함.*/}
      <OrangeButton label={"새로고침"} onClick={handleRefresh}>
        {" "}
      </OrangeButton>
    </>
  );
}

function ShowOkMsg(props) {
  return (
    <div className="p-3">
      <div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        인증에 성공했습니다.
        <br />
        <br />
      </div>
    </div>
  );
}

function ShowErrorMsg(props) {
  // props.message
  return (
    <div className="p-3">
      <div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        {props.message}
        <br />
        <br />
      </div>
      <OrangeButton label="돌아가기" onClick={() => window.history.back()} />
    </div>
  );
}

// 약관동의했는지 확인해서, 안했으면 약관동의 페이지로 넘어감
function checkTermsAgreed(props) {
  // props.boUrl: url prefix
  // props.username:
}
